/**
 * @typedef {object} ISubscriptionResource
 * @property {(args? : { clientId?: string }) => ng.IPromise<import('types/api').V2.FetchManagementSubscriptionStrategy.Response>} fetchManagementStrategy
 * @property {(args?: { clientId?: string }) => ng.IPromise<import('types/api').V2.CreateSubscription.Response >} createSubscription
 */

import { resourceHeaders } from './resource-actions.factory';

export default [
  '$http',
  SubscriptionResource,
];

/**
 * @param {ng.IHttpService} $http
 * @return {ISubscriptionResource}
 */
export function SubscriptionResource($http) {

  return {
    /**
     * @param {object} args
     * @param {string | null} args.clientId
     */
    fetchManagementStrategy(args) {
      return $http.post(
        '/api/v2/subscriptions/manage',
        { clientId: args.clientId },
        {
          headers: resourceHeaders.post,
        }
      ).then(resp => resp.data);
    },
    createSubscription(args) {
      return $http.post(
        '/api/v2/subscriptions',
        { clientId: args.clientId },
        {
          headers: resourceHeaders.post,
        }
      ).then(resp => resp.data);
    }
  };
}
